import clsx from 'clsx'

type SelectablePillProps = {
  label: string
  selected: boolean
  onClick: () => void
  /** Pulsing primary ring drawing attention while the group has no selection yet. */
  pulse?: boolean
  disabled?: boolean
  className?: string
}

export const SelectablePill = ({ label, selected, onClick, pulse, disabled, className }: SelectablePillProps) => (
  <button
    type="button"
    aria-pressed={selected}
    disabled={disabled}
    onClick={onClick}
    className={clsx(
      'rounded-full border px-4 py-1.5 text-sm font-medium transition-colors',
      selected
        ? 'border-primary/40 bg-primary/10 text-primary'
        : ['border-border text-foreground', !disabled && 'hover:bg-accent'],
      disabled && 'cursor-not-allowed opacity-50',
      pulse && 'animate-pill-pulse',
      className,
    )}
  >
    {label}
  </button>
)
